import { css } from "@emotion/react";
import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const SharedQuoteUploadWrapper = styled.div`
  align-items: center;
  color: ${theme.colors.darkBlues[75]};
  display: flex;
  flex-direction: column;
  text-align: center;

  .spotDownload {
    img {
      width: 42px;
    }
  }
  .uploadDragDrop {
    margin-bottom: 8px;
  }
`;

export const RFQContainerBase = styled.div`
  align-items: center;
  background: #ffffff;
  color: ${theme.colors.darkBlues[75]};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  padding: 58px 0 20px;
  text-align: center;
  cursor: pointer;
  /* transition: 0.3s; */
  i {
    color: ${theme.colors.blues[100]};
    font-size: 28px;
  }
  button {
    margin: 24px 0 20px;
  }
  span.prompt {
    color: #8495a3;
    display: block;
    min-height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
  }
`;

export const RFQContainerStandAlone = styled(RFQContainerBase)`
  border-radius: 3px;
  border: 1px solid #cac1d1;
  max-width: 915px;
  width: 100%;
`;

export const CTAWrapper = styled.div`
  border-radius: 3px;
  border: 1px dashed #476175;
  display: flex;
  max-width: 915px;
  min-width: 381px;
  width: 100%;
  background: #ffffff;
  flex-direction: column;
`;

export const CTAWrapperShared = styled(CTAWrapper)`
  flex-direction: row;
  ${SharedQuoteUploadWrapper} {
    width: 600px;
  }
  ${RFQContainerBase} {
    padding: 58px 20px 20px !important;
  }
`;

export const QuoteUploadWithRfqWrapper = styled.div`
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%2347617585' stroke-width='1' stroke-dasharray='3%2c 8' stroke-dashoffset='10' stroke-linecap='square'/%3e%3c/svg%3e");
  }
  &::before {
    content: "Or";
    position: absolute;
    top: 45%;
    right: -10px;
    background-color: white;
    padding: 3px;
    border-radius: 100px;
    z-index: 1;
  }
`;

export const SliceWrapper = styled.div`
  padding: 20px 6.75%;
  ${theme.largerThan.sm} {
    padding: 40px 12.5%;
  }
  & > * {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const CompactDualCTAWrapper = styled.div`
  padding: 16px 24px 32px 24px;
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.16);
  border-radius: 3px;

  h6 {
    padding: 0;
    margin: 0 0 8px 0;
    font-weight: 700;
    font-size: 13px;
    line-height: 20px;
  }

  ${SharedQuoteUploadWrapper} {
    padding: 12px 0 12px;
    cursor: pointer;

    .buttonGroupAlt {
      margin-bottom: 18px;
    }

    :hover {
      background-color: #f6f9ff;
    }
  }
`;

export const NestedCTADisplayWrapper = styled.div`
  h6 {
    margin-top: 32px;
  }

  .nestedCtaContent {
    display: flex;
    flex-direction: row;
    align-items: center;

    button {
      color: ${theme.colors.brandBlue};
      white-space: nowrap;
      margin-left: 14px;
    }

    p {
      margin: 0;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export const LoaderWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  justify-items: center;
  align-content: center;
`;

export const Loader = styled.div`
  width: 60px;
  aspect-ratio: 2;
  --_g: no-repeat
    radial-gradient(circle closest-side, ${theme.colors.blues[100]} 90%, #0000);
  background: var(--_g) 0% 50%, var(--_g) 50% 50%, var(--_g) 100% 50%;
  background-size: calc(100% / 3) 50%;
  animation: l3 1s infinite linear;

  @keyframes l3 {
    20% {
      background-position: 0% 0%, 50% 50%, 100% 50%;
    }
    40% {
      background-position: 0% 100%, 50% 0%, 100% 50%;
    }
    60% {
      background-position: 0% 50%, 50% 100%, 100% 0%;
    }
    80% {
      background-position: 0% 50%, 50% 50%, 100% 100%;
    }
  }
`;
